import { render } from "./ModDetalleReporte.vue?vue&type=template&id=52a6c4a0"
import script from "./ModDetalleReporte.vue?vue&type=script&lang=js"
export * from "./ModDetalleReporte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__